import {ReactSession} from "react-client-session";
import {AES, enc} from "crypto-js";

const NoticeBanner = (props) => {

    let dData, headerData2;
    if (ReactSession.get("PAL") != null) {
        let bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    return (
        <div style={{
            backgroundColor: "#e7f3ff",
            borderBottom: "2px solid #0d6efd",
            fontSize: "15px",
            color: "#084298",
            fontWeight: "500",
            height: "58px",
            display: "flex",
            alignItems: "center"
        }}
             className={"text-center"}>
            <div className="container-fluid">
                <span className="fw-bold me-2" style={{color: "#0a58ca"}}>
                    {dData?.notice_message ? dData.notice_message : ""}
                </span>
            </div>
        </div>
    );
};

export default NoticeBanner;